
export interface TwitchCreator {
  login: string;
  displayName: string;
  url: string;
}

export const TWITCH_CREATORS: TwitchCreator[] = [
  { login: "upside_tools", displayName: "Upside", url: "https://www.twitch.tv/upside_tools" },
  { login: "tjj530", displayName: "TJJ530", url: "https://twitch.tv/tjj530" },
  { login: "cmattdowns", displayName: "CMattDowns", url: "https://www.twitch.tv/cmattdowns" },
];

export const TWITCH_LIVE_POLL_INTERVAL_MS = 60_000;

export const TWITCH_WIDGET_AUTO_COLLAPSE_MS = 12_000;

export const TWITCH_WIDGET_SHOW_DELAY_MS = 3_000;

export const twitchDismissedKey = (userLogin: string) =>
  `upsider:twitch_live:dismissed:${userLogin}`;
